"use client"

import { useState } from "react"
import { X, Clock, Plus, Lock } from "lucide-react"
import Toast from "../Toast";
import Origins, { isAccountVerified, isValidEmail } from "../Helpers/Helpers";

const EmailVerificationModal = ({ isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState("")
  const [OTP, setOTP] = useState("")
  const [showOTP, setShowOTP] = useState(false)
  const [isSendOTPEnabled, setIsSendOTPEnabled] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);
  

  const showToast = (type, title, message = "", duration = 5000) => {
    setToast({ type, title, message, duration });
  };

  const closeToast = () => {
    setToast(null);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email || !isValidEmail(email)) return

    try {
      setIsLoading(true);
      setError(null);

      const requestBody = {
        email: email,
        env: process.env.REACT_APP_ENV_TYPE
      };

      const response = await fetch(
        "https://apis.metabuddy.app/flaskapp/send-otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNTI1MDkxNGMzMWJhMzJjYTVlZWVkZmUxOGRmYTJmODI0NzBjYmZjOGJjMWNkNzYzYWYxOTdhOGM3YzU0M2EwNGFhYjQ0MzVlMjViNjdjMGQiLCJpYXQiOjE3NDgwODcwMDguNjM5OTU5LCJuYmYiOjE3NDgwODcwMDguNjM5OTYzLCJleHAiOjE3Nzk2MjMwMDguNjI2ODYxLCJzdWIiOiI5MiIsInNjb3BlcyI6W119.ABLwCRB3JqBHDgIqijsOKo4OTx4W_tzjoOlPGhBpFC5NCc6_2mz4dRkSdKlCos6_vyG2m0h1mQlFeHCglwaZ2wTdV7qcf7IfYRu5ZtZMLKTQrLEg-ZuD4ICd6D-t4OEM3oVlLM7QW_VF4WLAXxldMxKshKiBTTPLspAC0eFRGz_XVWMqbl7bevbCTrNgh3DGqp5WyJ9lOO9qNO5Vq6KsaLEEWizj_Wm3FoeRV6S2IcvLCW9gus8PjEQsEYHm2OUhQUKax-rW7g8RTdTrh2eIApT8AlBeDpcrmHmudG-EySWFVsdX_aWffAIatOzowcc4KLBJJEBRXQ1A4F3GQsPQZYXCXuPOdihD6x1vuqUVwc5aN13YJ7rGm7AqlSLEXbqr0RSRAGVfdlV8Ms_OraFHCc4juc7WbQFQ0efLnXphUUWNZgtBc_Lw79m0JuyvM70l8Hcn_fo4OlqhlOfcLTQhrK21Tc0CnXN_JiJtl9H-Y6qNErB2DoCgsXjBz0a5OPUbXQ9WfMcJSMbJJmBV1qAoybQCwSCtlqQLmV-qttVJZ-Ib3orz0ZsQs_k2-bVYwYiXBNB3zki41X0_F2bC4o-oWxiIuk1L6LDFLkcg52EDRkosNWxI7Il-po4QvWU21DojaNLWqP-REfK94W6ZqbklS4wrxCz-BzvaBtRocS4aqKg",
          },
          body: JSON.stringify(requestBody),
        }
      );

      /*
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP ${response.status}: ${
            errorText || "Failed to load"
          }`
        );
      }*/

      const data = await response.json();

      if (data.status === "success") {
        setError(null);
        showToast(
          "success",
          "Success!",
          data.message
        );
        setShowOTP(true);
      } else {
        throw new Error(`${data.message || "Unknown error"}`);
      }
    } catch (err) {
      const errorMessage = `Failed to get otp: ${err.message}`;
      //setError(errorMessage);
      showToast("error", err.message);
      console.error("Error loading initial questions:", err);
    } finally {
      setIsLoading(false);
    }

  }

  const handleVerifyOTP = async (e) => {
    e.preventDefault()
    if (!OTP || !isValidEmail(email)) return

    try {
      setIsLoading(true);
      setError(null);

      const requestBody = {
        email: email,
        otp:OTP,
        env: process.env.REACT_APP_ENV_TYPE
      };

      const response = await fetch(
        "https://apis.metabuddy.app/flaskapp/verify-otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNTI1MDkxNGMzMWJhMzJjYTVlZWVkZmUxOGRmYTJmODI0NzBjYmZjOGJjMWNkNzYzYWYxOTdhOGM3YzU0M2EwNGFhYjQ0MzVlMjViNjdjMGQiLCJpYXQiOjE3NDgwODcwMDguNjM5OTU5LCJuYmYiOjE3NDgwODcwMDguNjM5OTYzLCJleHAiOjE3Nzk2MjMwMDguNjI2ODYxLCJzdWIiOiI5MiIsInNjb3BlcyI6W119.ABLwCRB3JqBHDgIqijsOKo4OTx4W_tzjoOlPGhBpFC5NCc6_2mz4dRkSdKlCos6_vyG2m0h1mQlFeHCglwaZ2wTdV7qcf7IfYRu5ZtZMLKTQrLEg-ZuD4ICd6D-t4OEM3oVlLM7QW_VF4WLAXxldMxKshKiBTTPLspAC0eFRGz_XVWMqbl7bevbCTrNgh3DGqp5WyJ9lOO9qNO5Vq6KsaLEEWizj_Wm3FoeRV6S2IcvLCW9gus8PjEQsEYHm2OUhQUKax-rW7g8RTdTrh2eIApT8AlBeDpcrmHmudG-EySWFVsdX_aWffAIatOzowcc4KLBJJEBRXQ1A4F3GQsPQZYXCXuPOdihD6x1vuqUVwc5aN13YJ7rGm7AqlSLEXbqr0RSRAGVfdlV8Ms_OraFHCc4juc7WbQFQ0efLnXphUUWNZgtBc_Lw79m0JuyvM70l8Hcn_fo4OlqhlOfcLTQhrK21Tc0CnXN_JiJtl9H-Y6qNErB2DoCgsXjBz0a5OPUbXQ9WfMcJSMbJJmBV1qAoybQCwSCtlqQLmV-qttVJZ-Ib3orz0ZsQs_k2-bVYwYiXBNB3zki41X0_F2bC4o-oWxiIuk1L6LDFLkcg52EDRkosNWxI7Il-po4QvWU21DojaNLWqP-REfK94W6ZqbklS4wrxCz-BzvaBtRocS4aqKg",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        setError(null);
        showToast(
          "success",
          "Success!",
          data.message
        );
        localStorage.setItem("email", email);
        handleClose(email);
      }else if (data.status === "error") {
        setError(data.message);
        showToast(
          "error",
          "Oops!",
          data.message
        );
      } else {
        throw new Error(`${data.message || "Unknown error"}`);
      }
    } catch (err) {
      const errorMessage = `Failed to load: ${err.message}`;
      //setError(errorMessage);
      showToast("error", err.message);
      console.error("Error loading initial:", err);
    } finally {
      setIsLoading(false);
    }

  }

  const handleClose = (value) => {
    setEmail("")
    setOTP("");
    setShowOTP(false);
    if (value){
      onSubmit();
    }else{
      onClose();
    }
  }

  const handleResend = () => {
    setShowOTP(false);
    setOTP("");
  }

  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-t-3xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <Lock className="w-5 h-5 text-white" />
            </div>
            <h2 className="text-xl font-bold">Authenticate</h2>
          </div>
          {/* 
          <button onClick={handleClose} className="p-2 hover:bg-white/20 rounded-xl transition-colors duration-200">
            <X className="w-5 h-5" />
          </button> */}
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-8">
          <div className="space-y-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Lock className="w-8 h-8 text-blue-600" />
              </div>

              {!showOTP ? (
                <>
                  <label className="block text-lg font-bold text-gray-800 mb-2">Add Your Email</label>
                  <div className="relative">
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email"
                      className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-2xl text-center font-regular text-gray-800"
                      required
                    />
                  </div>
                  <div className="flex gap-4 mt-8">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="flex-1 px-6 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-2xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 font-medium"
                    >
                      {isLoading ? (
                        <>
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          <Plus className="w-5 h-5" />
                          GET OTP
                        </>
                      )}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <label className="block text-lg font-bold text-gray-800 mb-2">Add OTP</label>
                  <div className="relative">
                    <input
                      type="text"
                      value={OTP}
                      onChange={(e) => setOTP(e.target.value)}
                      placeholder="OTP"
                      className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-2xl text-center font-regular text-gray-800"
                      required
                    />
                  </div>
                  <p className="text-sm text-gray-600 mt-4">
                    Didn’t receive code?{" "}
                    <button
                      type="button"
                      onClick={handleResend}
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      Resend
                    </button>
                  </p>
                  <div className="flex gap-4 mt-8">
                  <button
                    type="button"
                    onClick={handleVerifyOTP}
                    disabled={isSubmitting}
                    className="flex-1 px-6 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-2xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 font-medium"
                  >
                    {isLoading ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Processing...
                      </>
                    ) : (
                      <>
                        <Plus className="w-5 h-5" />
                        Verify OTP
                      </>
                    )}
                  </button>
                </div>
                </>
              )}
              <p className="text-sm text-gray-500 mt-3"></p>
            </div>
          </div>

        </form>

        {toast && <Toast toast={toast} onClose={closeToast} />}
      </div>
    </div>
  )
}

export default EmailVerificationModal
